<template>
    <PageTemplateContent>
        <BaseHero
            title="Copyright and ownership"
            data-span-all
        />
        <ContentBlocksText>
            <p>
                Though copyright and ownership legislation may vary from country to country, MedPeers considers uploaded videos to be copyrighted to the person(s) who created and uploaded the content (herein referred to as the authors) and co-owned by the person(s) who created and uploaded the content, the affiliated institution where the content was created and the patient involved.
            </p>

            <p>Should the author(s) be employed, copyright may lie partially or completely with their affiliated institution. If the institution where the content was created does not match the affiliated institution, the author(s) should recognize both their (relevant) affiliations as well as the center where the work was created. The author(s), the (relevant) affiliated institution and the patients or their legal council(s) or next of kin all reserve the right to request partial or complete removal of the content.</p>

            <p>
                Though MedPeers will verify all content regarding the presence of identifiable data, the presence of commercial material and/or the presence of content that has no educational purpose or data that could intendedly or unintendedly  harm others, the content is the sole responsibility of the author(s).
            </p>

            <p>
                MedPeers reserves the right to remove material should they believe patients, or coworkers that did not consent, can be identified on the data available, should they believe the video was uploaded with direct or indirect commercial intent or should they believe the uploaded data has no educational value or contains data that could intendedly or unintendedly  harm others.
            </p>
            <p>
                A watermark will be added to all uploaded video content for the purpose of identification and copyright protection. 
            </p>
        </ContentBlocksText>
    </PageTemplateContent>
</template>

<script setup>
const { asset } = useBaseUrl();

useSeoMeta({
    title: 'MedPeers | Copyright and ownership',
    description: 'A secure, peer-reviewed and quality-controlled platform offering educational videos of medical procedures.',
    ogImage: asset('/images/og/default.png')
});
</script>
